import Head from 'next/head'
import { useRouter } from 'next/router'
import { FAQPageJsonLd } from 'components/shared/schema/FaqSchema'
import { ArticleJsonLd } from 'components/shared/schema/article'
import SoftwareContent from 'components/software'
import { Software_With_NavDocument } from 'graphql/generated/types'
import ApplicationLayout from 'layouts/application'
import { pageUri } from 'shared/util'
import { initializeApollo, addApolloState } from 'util/apolloClient'

const title = (name) => `${name} Defination, meaning, examples`
const description = (name) => `${name} meaning, examples`

export default function Software(props) {
  const router = useRouter()
  const { asPath } = router
  const { data: pageData } = props

  const {
    all_brokers: { data: allBrokers },
    selected_software: softwareRecord,
    nav_calculators: { data: navCalculators },
    all_pages: { data: allPages },
  } = pageData
  const software = softwareRecord.data[0].attributes
  const {
    name,
    seo_meta: seoMeta,
    articles: { data: articleData },
    image,
  } = software
  const { title: recordTitle, description: recordDescription } = seoMeta || {}

  const pageTitle = title(name)
  const pageDescription = description(name)

  let images = []

  if (image?.file?.data) {
    const availableImage =
      image.file.data[0]?.attributes?.formats?.large ||
      image.file.data[0]?.attributes?.url
    images = [availableImage]
  }
  return (
    <ApplicationLayout
      allBrokers={allBrokers}
      navCalculators={navCalculators}
      allPages={allPages}
    >
      <Head>
        <title>{recordTitle || pageTitle}</title>
        <meta
          name="description"
          content={recordDescription || pageDescription}
        />
      </Head>
      <ArticleJsonLd
        url={pageUri(asPath)}
        images={images}
        title={pageTitle}
        description={pageDescription}
      />
      <FAQPageJsonLd articleDataArr={articleData} />
      <SoftwareContent software={software} />
    </ApplicationLayout>
  )
}

export async function getServerSideProps(context) {
  const apolloClient = initializeApollo()
  const {
    query: { slug },
  } = context

  const queryResults = await apolloClient.query({
    query: Software_With_NavDocument,
    variables: { slug },
  })

  const { data } = queryResults

  return addApolloState(apolloClient, {
    props: { data },
  })
}
